<template>
  <div v-if="modelBlog?.elements" class="flex flex-col mb-20 overflow-visible">
    <BlogContentEditDropper
      v-for="(element,i) in modelBlog.elements"
      :key="element.id+'_'+i"
      v-model:element="modelBlog.elements[i]"
      v-model:blog="modelBlog"
      @remove="methodRemoveElement(modelBlog, element)"
      @moveup="methodMoveElement(modelBlog as Blog, element, false)"
      @movedown="methodMoveElement(modelBlog as Blog, element, true)"
      @addabove="methodAddElement(modelBlog as Blog, element, false)"
      @addbelow="methodAddElement(modelBlog as Blog, element, true)"
      />

    <blog-button
      class="dark m-4"
      text="Add content"
      @click="$emit('addabove',0)"
      />
  </div>
</template>

<script setup lang="ts">
defineEmits(['remove','addbelow','addabove','moveup','movedown'])
const modelBlog = defineModel<Blog>()
</script>
